export function OnEnterBlurDirective() {
  return function (scope, element) {
    element.bind('keydown keypress', function (event) {
      if (event.which === 13) {
        element.blur();
        // (document.activeElement as HTMLElement).blur();

        event.preventDefault();
      }
    });
  };
}
